// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Switch_Switch__LBtd_","SwitchOn":"Switch_SwitchOn__2pfu_","SwitchDisabled":"Switch_SwitchDisabled__2l5Ba"};